"use client";

import { useRef, useState } from "react";

type Choice = { value: string; label: string; detail?: string };

export function GridPicker({ id, title, value, placeholder, choices, disabled, onChange }: {
  id: string;
  title: string;
  value: string;
  placeholder: string;
  choices: Choice[];
  disabled: boolean;
  onChange: (value: string) => void;
}) {
  const dialog = useRef<HTMLDialogElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const selected = choices.find((choice) => choice.value === value);

  function close() { dialog.current?.close(); }

  return <div className="grid-picker">
    <button ref={trigger} id={id} type="button" className="picker-trigger" disabled={disabled}
      aria-label={`${title}: ${selected?.label ?? placeholder}`} aria-haspopup="dialog" aria-expanded={open}
      aria-controls={`${id}-panel`} aria-describedby={`${id}-status`}
      onClick={() => {
        dialog.current?.showModal();
        setOpen(true);
        dialog.current?.querySelector<HTMLButtonElement>('[aria-pressed="true"]')?.focus();
      }}>
      <span className="picker-indicator" aria-hidden="true" />
      <span className="picker-value">{selected?.label ?? placeholder}</span>
      <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m4 6 4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" /></svg>
    </button>
    <dialog ref={dialog} id={`${id}-panel`} className="picker-panel" aria-labelledby={`${id}-heading`}
      onClose={() => { setOpen(false); trigger.current?.focus(); }}
      onClick={(event) => {
        if (event.target !== event.currentTarget) return;
        const bounds = event.currentTarget.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }}>
      <div className="picker-heading">
        <div><p className="eyebrow">PILIHANMU</p><h2 id={`${id}-heading`}>{title}</h2></div>
        <span className="picker-count">{choices.length} pilihan</span>
        <button className="picker-close" type="button" onClick={close} aria-label={`Tutup pilihan ${title.toLowerCase()}`}>
          <svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m4 4 8 8M12 4l-8 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" /></svg>
        </button>
      </div>
      <div className="picker-grid">
        {choices.map((choice) => <button key={choice.value} type="button" className="picker-choice" aria-pressed={choice.value === value}
          onClick={() => { onChange(choice.value); close(); }}>
          <span className="choice-name">{choice.label}</span>
          {choice.detail && <small>{choice.detail}</small>}
          {choice.value === value && <svg className="choice-check" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="m3 8 3 3 7-7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" /></svg>}
        </button>)}
      </div>
    </dialog>
  </div>;
}

